module.exports = __webpack_public_path__ + "img/m_contents_bus@2x.ecb0a5ce.png";